<template>
    <div id="leaseContractExpiry">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name"><div class="page-title">{{pageTitle}}</div>
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <div class="web-action-btn">
                        <div class="btn-groups text-right">
                            <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                                <i class="fp-export"></i> Export
                            </a>
                            <!-- <router-link  v-if="canAddAsset" class="btn btn-primary" v-bind:to="{name: 'AssetComponentCreate'}" > <i class="fp-add"></i> Add Component</router-link> -->
                            <!-- <router-link  v-if="canAddAsset && hideButton === false" class="btn btn-primary" v-bind:to="{name: 'AssetCreate'}" > <i class="fp-add"></i> Add</router-link> -->
                            <!-- <router-link v-if="programMode && hideButton === false" class="btn btn-secondary" v-bind:to="{name: 'ProgramList'}" > <i class="fp-back"> </i> Back</router-link> -->

                        </div>
                    </div>
                    <div class="mobile-action-btn elipse-btn">
                        <button type="button" class="btn btn-elipse" data-toggle="dropdown" data-toggle-position="left" aria-expanded="false" v-on:click.prevent="myFunction">
                            <i class="fp-ellipsis-v"></i>
                        </button>
                        <div id="myDropdown" class="dropdown-content">
                            <ul>
                                <li><a href="javascript:void(0)" class="" v-on:click="exportReports()">Export</a></li>
                                <!-- <li> <router-link v-if="hideButton === false && canAddAsset" v-bind:to="{name: 'AssetCreate'}"> Add</router-link> </li> -->
                                <!-- <li> <router-link v-if="hideButton === false && canAddAsset" v-bind:to="{name: 'AssetComponentCreate'}"> Add Component</router-link> </li> -->

                            </ul>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content asset-lists">

                        <data-table-filter-config :moduleName="'leaseContractExpiry'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                            <div class="data-table bg-white overflow-hidden">
                              <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                              <section class="bg-white data-table">
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange" :moduleName="'leaseContractExpiry'" :position="'top'">
                                  </custom-pagination>

                                  <vue-good-table
                                          ref="listleaseContractExpiryTable"
                                          mode="remote"
                                          title="Lease Contract Expiry"
                                          @on-page-change="onPageChange"
                                          @on-selected-rows-change="selectionChanged"
                                          @on-column-filter="onColumnFilter"
                                          @on-per-page-change="onPerPageChange"
                                          @on-sort-change="onSortChange"
                                          :totalRows="totalRecords"
                                          :columns="userColumns"
                                          :rows="rows"
                                          @on-select-all="onSelectAll"
                                          :pagination-options="{
                                              enabled: false,
                                              position: 'both',
                                              setCurrentPage:listCurrentPage,
                                              perPage: perPage,
                                              perPageDropdown:dropDownPerPage,
                                              dropdownAllowAll: false,
                                          }"
                                          :select-options="{
                                              enabled: false,
                                              selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                              selectionInfoClass: 'custom-class',
                                              selectionText: 'rows selected',
                                              clearSelectionText: 'clear',
                                          }"
                                          :search-options="{
                                              enabled: false,
                                          }"
                                          :sort-options="{
                                              enabled: true,
                                              initialSortBy: {field: 'unit_no', type: 'asc'}
                                          }"
                                  >

                                      <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                          <div :key="key">
                                              <div>
                                                  {{props.formattedRow[props.column.field]}}
                                              </div>
                                          </div>
                                      </template>
                                      <div slot="selected-row-actions">
                                          <!-- commented delete button because asset is used in other modules also -->
                                          <!-- <button v-if="canDeleteAsset" id="deleteGroupBtn" v-on:click.prevent="VehicleDelete" class="btn btn-danger">Delete</button> -->
                                          <!-- <button v-if="recallMode && !programMode" id="recallBtn" v-on:click.prevent="openRecallModal" class="btn btn-primary">Add Asset To Recall</button>
                                          <button v-if="programMode" id="recallBtn" v-on:click.prevent="addAssetToProgram" class="btn btn-primary">Add Asset To Program</button> -->
                                      </div>
                                  </vue-good-table>
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                              </section>
                            </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

    import EventBus from "./event-bus";
    import Vue from "vue";

    
    



    import {commonMixins} from '../mixins/commonMixins';
    import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "LeaseContractExpiry",
        metaInfo: {
            // title will be injected into parent titleTemplate
            title: "Lease Contract Expiry List | " +process.env.COPYRIGHT_NAME
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            pageTitle:"Lease Contract Expiry List",
            hideButton: false,
            availabilityFromDate:null,
            availabilityToDate:null,
            availabilityLocation:"",
            availabilityAssetType:"",
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            canViewAsset:true,
            userColumns:[],
            columns: [
                {
                    label: 'Unit Number',
                    field: 'unit_no',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    width:'90px',
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "#Unit", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    html:true
                },
                {
                    label: 'Customer Unit Number',
                    field: 'customer_unit_no',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "#Unit", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    html:true
                },
                {
                    label: 'Serial Number',
                    field: 'vin',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "VIN", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Contract Type',
                    field: 'conType',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Contract Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Agreement',
                    field: 'contract_code',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Agreement", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'In Service Date',
                    field: 'date_in_service',
                    filterable: true,
                    fpFieldType:"custom_date",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Billing Frequency',
                    field: 'billing_frequency',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: 'Customer',
                    field: 'customer',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Customer", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Location',
                    field: 'assigned_facility',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Facility", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Contract Expiry Date',
                    field: 'expiry_date',
                    filterable: true,
                    fpFieldType:"custom_date",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Terms',
                    field: 'term',
                    filterable: true,
                    fpFieldType:"integer",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Term", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                 {
                    label: 'Contract Status',
                    field: 'status',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Contract Status", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Pending','Active','Closed'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Unit Year',
                    field: 'year',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Year", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Make',
                    field: 'vehicle_manufacturer',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Equipment Manufacturer", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Model',
                    field: 'vehicle_model',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Equipment Model", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Equipment Type',
                    field: 'asset_type',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Asset Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Pool',
                    field: 'asset_pool',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Asset Pool", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Salesperson Contract',
                    field: 'sale_contract',
                    fpFieldType:"text",
                    filterable: false,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Asset Pool", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable : false
                },
                {
                    label: 'Fixed Annual Revenue',
                    field: 'fixed_rev',
                    filterable: false,
                    fpFieldType:"integer",
                    type : 'number',
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: 'Variable Annual Revenue',
                    field: 'variable_rev',
                    filterable: false,
                    fpFieldType:"integer",
                    type : 'number',
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: 'Total Annual Revenue',
                    field: 'total_rev',
                    filterable: false,
                    fpFieldType:"integer",
                    type : 'number',
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: 'Fixed Rate',
                    field: 'fixed_rate',
                    filterable: false,
                    fpFieldType:"integer",
                    type : 'number',
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: 'Distance Variable Rate',
                    field: 'distance_rate',
                    filterable: false,
                    fpFieldType:"integer",
                    type : 'number',
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: 'Reefer Hour Variable Rate',
                    field: 'rfhour_rate',
                    filterable: false,
                    fpFieldType:"integer",
                    type : 'number',
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: 'Park Rate',
                    field: 'park_rate',
                    filterable: false,
                    fpFieldType:"integer",
                    type : 'number',
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: 'Distance Estimated Usage',
                    field: 'estimated_miles',
                    // type : 'number',
                    filterable: false,
                    fpFieldType:"integer",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: 'Reefer Hour Estimated Usage',
                    field: 'estimated_hour',
                    // type : 'number',
                    filterable: false,
                    fpFieldType:"integer",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: 'Remaining Months',
                    field: 'remaining_month',
                    filterable: false,
                    fpFieldType:"integer",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: 'Current Facility',
                    field: 'location',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Facility", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'SalesRep Customer',
                    field: 'sales_person',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Sales Person", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    // sortable:false
                },
                {
                    label: 'Number of month to look ahead',
                    field: 'no_of_month',
                    filterable: false,
                    fpFieldType:"is",
                    hidden:true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                }
            ],
            rows: [],
            totalRecords: 0,
            canDeleteAsset: false,
            loading:false,
            canAddAsset:false,
            canUpdateAsset:false,
            accessCheckAvailability:false,
            selectedFile:"",
            recallMode:false,
            errorDetails:'',
            recalls:'',
            recallArr:[],
            assetRowCheckbox:false,
            action:"list",
            submitBtnText:"Submit",
            pageKey:"_vehicle_list_",
            programMode:false,
            batchProcess:0,
            batchNum:"",
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'lease_contract_expiry_report') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'delete_asset') {
                            self.canDeleteAsset = true;
                        }
                        if (permissions[i].name == 'add_asset') {
                            self.canAddAsset = true;
                            self.canUpdateAsset = true;
                        }
                        if (permissions[i].name == 'view_asset') {
                            self.canViewAsset = true;
                        }
                    }
                }

            }
        },
        created: function() {

        },

        mounted: function() {

            var self = this;

            //self.loadList();
            self.getPermissions();

        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listleaseContractExpiryTable.unselectAllInternal();
            },
            selectionChanged(param) {
                var self = this;
                self.serverParams.selectedAll = false;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                return;

            },
            // exportReports: function() {
            //     EventBus.$emit("clearSelection", false);
            //     var self = this;
            //     this.action = "export";
            //     this.loadList();
            // },

            loadList() {

                var self = this;
                self.loading = true;

                var selectedRows = [];

                //because on first load list not initialize
                var data = this.$refs['listleaseContractExpiryTable'].selectedRows;
                for ( var i = 0; i < data.length; i++ ) {
                    selectedRows.push(this.$refs['listleaseContractExpiryTable'].selectedRows[i].id)
                }

                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    selectedRows:selectedRows,
                    action:self.action,
                    selectedAll:self.serverParams.selectedAll

                };

                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/lease-contract-expiry/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {

                            if (self.action == "export" ||  self.action == "export_queue") {
                                if ( data.code == "201" ) {
                                    alert(data.message);
                                } else {
                                    if ( self.action == "export" ) {

                                        self.excel = data.content.web;
                                        var save = document.createElement("a");
                                        save.href = self.excel;
                                        save.download = data.content.web;
                                        save.target = "_blank";

                                        document.body.appendChild(save);
                                        save.click();
                                        document.body.removeChild(save);
                                    } else {

                                        self.batchProcess = 1;
                                        self.batchNum = data.content;
                                    }
                                }

                              self.action = "list";
                              // self.loadList();

                            } else {
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.filteredFlag = false;
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;

                        if ( self.action == "export" ) {
                            self.generateStatusCodeMessage(jqXHR,true,'export-asset-list')
                        }
                        else{
                            self.generateStatusCodeMessage(jqXHR,false,'get-asset-list')
                        }

                    }
                });
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/LeaseContractExpiryReport.vue